import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken
} from '@/utils/auth'

NProgress.configure({
  showSpinner: false
})
const whiteList = ['/login', '/register', '/foundPassword']
// '/home', '/news', '/aboutUs', '/apps', '/appsDetail',

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (!store.getters.roles || store.getters.roles.length === 0) {
      // 判断当前用户是否已拉取完user_info信息
      store.dispatch('GetInfo').then(() => {
        store.dispatch('refreshInfo').then(() => {
          next()
        }).catch(err => {})
        // store.dispatch('dept/getDeptList')
        // store.dispatch('project/getProjectList')
        // hack方法 确保addRoutes已完成
      }).catch(err => {
        store.dispatch('LogOut').then(() => {
          Message.error(err)
          next({
            path: '/login'
          })
        })
      })
    } else {
      next()
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // Message({
      //   message: '没有登入暂无权限',
      //   type: 'error',
      //   duration: 2000
      // })
      // next() // 否则全部重定向到登录页
      next({
        path: '/login'
      })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})